import { Col, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';
import { LoadingOutlined } from '@ant-design/icons';
import LeftContainer from './LeftContainer';
import RightContainer from './RightContainer';
import RightIconContainer from './RightIcons';
import Header from './Hearder/Header';
import './linedashboard.css';
import SpeechAudio from '../LineDashboardMQ/SpeechAudio';
import LinePopup from '../LineDashboardMQ/LinePopup';
import RFIDModal from '../../components/RFIDModal';
const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const MainDashboardZen = ({
    selectedLid,
    setSelectedLid
}) => {
    const [loading, setLoading] = useState(false);
    const [settings, setsettings] = useState(null);
    const [settingValues, setsettingValues] = useState(null);
    const [lineDetails, setlineDetails] = useState(null);
    const [compliance, setcompliance] = useState(null);
    const [loaded, setloaded] = useState(false);
    const [loginError, setloginError] = useState(false);
    const [variableData, setVariableData] = useState(null);

    const [target, setTarget] = useState(null);
    const [actual, setActual] = useState(null);
    const [difference, setDifference] = useState(null);
    const [rank, setRank] = useState(null);
    const [lineDashImageSrc, setlineDashImageSrc] = useState(null);
    const [dBlock, setDBlock] = useState(null);
    const [mini, setMini] = useState(null);
    const [mainG, setMainG] = useState(null);
    const [aux, setAux] = useState(null);

    const [lineLeaderModal, setLineLeaderModal] = useState(false);

    const [flipInterval, setFlipInterval] = useState(null);

    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [refreshLineDashboard, setRefreshLineDashboard] = useState(0);

    const onRefreshLineDashboard = () => {
        setRefreshLineDashboard(refreshLineDashboard ? 0 : 1);
    }

    const getLineDashData = () => {
        liracrypt
            .get("/linedash/linedashvariabledata", {
                lid: selectedLid,
                proj: "all",
            })
            .then(({ data }) => {
                setTarget(data.data["lD_ShiftPerf_Tgt"]);
                setActual(data.data["lD_ShiftPerf_Actual"]);
                setDifference(data.data["lD_ShiftPerf_Diff"]);
                setRank(data.data["lD_LineRank_Main"]);

                setMainG(data.data["lD_MainGauge"]);
                const temp = {};
                Object.keys(data.data).forEach((key) => {
                    if (key.includes("lD_DataBlock")) {
                        temp[key] = data.data[key];
                    }
                });

                const gtemp = {};
                Object.keys(data.data).forEach((key) => {
                    if (key.includes("lD_MicroGauge")) {
                        gtemp[key] = data.data[key];
                    }
                });

                setMini(gtemp);
                setDBlock(temp);
                setVariableData(data);
                setsettingValues(data.data);
            })
            .catch(function (error) {
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setloginError(true);
                    }
                }
            });
    }

    useEffect(() => {
        getLineDashData();
        let lineDashInterval = setInterval(() => {
            getLineDashData();
        }, 10000);
        return () => {
            clearInterval(lineDashInterval);
        }
    }, [selectedLid, refreshLineDashboard]);

    useEffect(() => {
        setLoading(true);
        Promise.all([
            liracrypt.get("/linedash/linedashuiconfig", {}),
            liracrypt.get("/linedash/linedashvariabledata", {
                lid: selectedLid,
                proj: "all",
            }),
            liracrypt.get("/linedash/linedashfixeddata", {
                lid: selectedLid,
            }),
            liracrypt.get("/linedashboard/compliance", {
                lid: selectedLid,
                proj: "compliance",
            }),
        ]).then(([lineDashLoad, lineDashValues, lineDetails, compliance]) => {
            setcompliance(compliance.data.data["compliance"]);
            setsettingValues(lineDashValues.data.data);
            setlineDetails(lineDetails.data.config);
            setsettings(lineDashLoad.data.data);

            setlineDashImageSrc(lineDashLoad.data.data["imgSrc"]);
            setAux(lineDashLoad.data.data.auxMenu);
            setFlipInterval(
                lineDashLoad.data.data.ldDataBlockFlipInterval
                    ? lineDashLoad.data.data.ldDataBlockFlipInterval
                    : 8000
            );
            setloaded(true);
            setLoading(false);
            if (lineDashLoad.data.data?.identifyLineLeader === true) {
                setLineLeaderModal(true);
            }
        });

        return () => {
            //   clearInterval(inter);
        };
    }, [selectedLid, refreshLineDashboard]);

    return (
        <>
            {loading ?
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh' }}>
                    <Spin indicator={antIcon} />
                </div> :
                <div className='main-dashboard-zen'>
                    {settings !== null && settingValues !== null && loaded === true ?
                        <>
                            <Header
                                settings={settings}
                                settingValues={{
                                    settingValues,
                                    ld_PageTitle: lineDetails["ld_PageTitle"],
                                }}
                            />

                            <Row>
                                {
                                    mini ?
                                        <Col lg={11} md={24} sm={24} xs={24} className='left-container'>
                                            <LeftContainer
                                                refreshLineDashboard={onRefreshLineDashboard}
                                                lineDashImageSrc={lineDashImageSrc}
                                                lid={selectedLid}
                                                settings={settings}
                                                Actual={actual}
                                                Diff={difference}
                                                Target={target}
                                                Rank={rank}
                                                mini={mini}
                                                dBlock={dBlock}
                                                mainG={mainG}
                                                settingValues={{
                                                    ...settingValues,
                                                    ld_PartDet_pno: lineDetails["ld_PartDet_pno"],
                                                    ld_PartDet_Pname: lineDetails["ld_PartDet_Pname"],
                                                    ld_PartDet_Cust: lineDetails["ld_PartDet_Cust"],

                                                }}
                                            />
                                        </Col> : <></>
                                }

                                <Col lg={12} md={24} sm={24} xs={24} className='right-container'>
                                    <RightContainer
                                        settings={settings}
                                        lid={selectedLid}
                                        settingValues={{
                                            ...settingValues,
                                            ...lineDetails,
                                        }}
                                        dBlock={dBlock}
                                        selectedLid={selectedLid}
                                        mini={mini}
                                        flipInterval={flipInterval}
                                        aux={aux}
                                    />
                                </Col>
                                <Col lg={1} md={24} sm={24}>
                                    <RightIconContainer
                                        refreshLineDashboard={onRefreshLineDashboard}
                                        rightContainer={{
                                            andon: settings.ld_Andon,
                                            tabs: settings.ld_Tab_Main,
                                        }}
                                        selectedLid={selectedLid}
                                        compliance={compliance}
                                        aux={aux}
                                        setSelectedLid={setSelectedLid}
                                    />
                                </Col>
                            </Row>
                            <SpeechAudio selectedLid={selectedLid} />
                            {
                                settings?.auxFunctions?.popUpMsg?.enable ?
                                    <LinePopup auxFunctions={settings?.auxFunctions?.popUpMsg} selectedLid={selectedLid} refreshLineDashboard={onRefreshLineDashboard} /> : <></>
                            }
                            {
                                settings?.auxFunctions?.rfid?.enable ?
                                    <RFIDModal selectedLid={selectedLid} auxFunctions={settings?.auxFunctions?.rfid} /> : <></>
                            }
                        </> : <></>
                    }
                </div>}
        </>
    )
};

export default MainDashboardZen;